module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/form-group/form-group.component.html
// module id = ../../../../../app/shared/components/easyForms/components/form-group/form-group.component.html
// module chunks = main